export default "__VITE_PUBLIC_ASSET__dc620eca__"